var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:{
        busy: _vm.busy,
        outline: _vm.outline,
        compact: _vm.compact,
        danger: _vm.danger
    },attrs:{"type":"submit","disabled":_vm.disabled}},_vm.disabled ? null : _vm.$listeners),[(_vm.busy)?_c('MaterialDesignIcon',{staticClass:"spinner",attrs:{"icon":_vm.mdiLoading,"spin":""}}):_vm._e(),(_vm.state.showProgress)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.trailingIcon)?_c('MaterialDesignIcon',{staticClass:"icon",attrs:{"icon":_vm.trailingIcon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }